module.exports = __webpack_public_path__ + "img/2.b63d9a12.png";